import { useRef, useState } from 'react'
import { IconButton } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

import { AccountsListPopover } from './accounts-list-popover.component'
import { IProfileUserResponse } from 'src/types'

import { useStyles } from '../styles'

interface IAccountsListButtonProps {
  accounts: IProfileUserResponse['accounts']
}

const AcccountsListButton = ({ accounts }: IAccountsListButtonProps) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement | null>(null)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <IconButton ref={anchorRef} className={classes.selectionIconButton} onClick={handleOpen}>
        <MoreHorizIcon style={{ color: '#999999' }} />
      </IconButton>
      <AccountsListPopover
        open={open}
        handleClose={handleClose}
        anchorRef={anchorRef}
        accounts={accounts}
      />
    </>
  )
}

export { AcccountsListButton }
